/* Tab styles */
.root {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.list {
    background: var(--mantine-color-dark-7);
    display: flex;
    flex-wrap: nowrap;
}

.tab {
    flex: 1;
    color: white;
    font-weight: 500;
    height: 40px;

    &[data-active] {
        background-color: var(--mantine-color-dark-5);
    }

    &:hover {
        background-color: var(--mantine-color-dark-5);
    }
}

.panel {
    height: 100%;
}

.tabPanel {
    position: relative;
}
